
import { DisenioPaginas } from "../../layout";
import { useBodegasQuery } from "../../../hooks";
import { BuscadorSoloValor, CargandoMedio, TablaListBodegas } from "../../components";




export const ListadoBodegas = () => {


    const { bodegasListQuery, page, termino, chagePage, chageTermino } = useBodegasQuery()



    return (

        <DisenioPaginas titulo="Listado de Bodegas" url="add/bodega">
            {(bodegasListQuery.isLoading)
            ?   <CargandoMedio titulo="Cargando Bodegas..." />
            :   <>
                <BuscadorSoloValor termino={termino} chageTermino={chageTermino} 
                    titulo='Buscar bodegas...' place='Buscar x nombre...'
                />
                <TablaListBodegas data={bodegasListQuery.data || []} chagePage={chagePage} page={page} />
                </>
            }

        </DisenioPaginas>

    )
}
